import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Search, Building2, MapPin, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

const ROOM_IMAGE = "https://customer-assets.emergentagent.com/job_bf1ebca5-1fd5-4042-b351-0048fc2281bc/artifacts/2n81eydn_20230524_153410.jpg";

const site = {
  name: 'AERH Formations Tahiti',
  address: '10 rue Georges Lagarde, 98713 Papeete, Polynésie Française, Papeete',
  description: 'Centre de formation professionnelle à Papeete. Salles équipées pour vos réunions, séminaires et formations.',
  rooms: 'Plusieurs salles',
  image: ROOM_IMAGE,
  location: 'Papeete',
  available: true
};

export const RoomSitesPage = () => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const showSite = search === '' || site.name.toLowerCase().includes(search.toLowerCase()) || site.address.toLowerCase().includes(search.toLowerCase());

  return (
    <div className="bg-[#F8FAFC] min-h-[60vh]" data-testid="room-sites-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-2">
          <span className="text-[#0D9488] font-semibold text-sm uppercase tracking-wider">Découvrir</span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#1F2937] mb-2" data-testid="sites-title">
          Nos sites & établissements
        </h1>
        <p className="text-gray-500 mb-8">
          Trouvez la salle idéale pour votre réunion, séminaire ou formation.
        </p>

        {/* Search bar */}
        <div className="flex gap-3 mb-10 max-w-2xl" data-testid="sites-search">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <Input
              placeholder="Rechercher par nom ou ville..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-10"
              data-testid="sites-search-input"
            />
          </div>
          <Button
            variant="outline"
            className="border-[#0D9488] text-[#0D9488] hover:bg-[#0D9488]/10"
            onClick={() => setSearch('')}
            data-testid="sites-reset"
          >
            Réinitialiser
          </Button>
        </div>

        {/* Site Card */}
        {showSite && (
          <div className="max-w-lg rounded-xl overflow-hidden shadow-md border border-gray-200 bg-white" data-testid="site-card">
            <div className="relative">
              <img src={site.image} alt={site.name} className="w-full h-52 object-cover" />
              <span className="absolute top-3 left-3 bg-[#0D9488] text-white text-xs font-semibold px-2.5 py-1 rounded-md">
                {site.location}
              </span>
              {site.available && (
                <span className="absolute top-3 right-3 bg-[#0D9488] text-white text-xs font-semibold px-2.5 py-1 rounded-md">
                  Disponible
                </span>
              )}
            </div>
            <div className="p-5">
              <h3 className="font-bold text-lg text-[#1F2937] mb-1">{site.name}</h3>
              <p className="flex items-start gap-1 text-sm text-gray-500 mb-3">
                <MapPin className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                {site.address}
              </p>
              <p className="text-sm text-gray-600 mb-4">{site.description}</p>
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1.5 text-sm text-gray-500">
                  <Building2 className="w-3.5 h-3.5" />
                  {site.rooms}
                </span>
                <Button
                  onClick={() => navigate('/location-salles/sites/aerh-tahiti')}
                  className="bg-[#0D9488] hover:bg-[#0F766E] text-white"
                  data-testid="site-voir-salles"
                >
                  Voir les salles
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        )}

        {!showSite && (
          <p className="text-gray-500 text-center py-12">Aucun établissement trouvé pour "{search}"</p>
        )}
      </div>
    </div>
  );
};

export default RoomSitesPage;
